/**
 * Copyright 2012-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Changes the case of the first letter of a given number of words in a string.
 * @author Randika Hapugoda
 */
@Pipe({ name: 'camelCase', pure: false })
export class CamelCasePipe implements PipeTransform {
  transform(input: string, length: number): string {
    if (input == undefined) return '';
    return input.charAt(0).toUpperCase() + input.substring(1).replace(/[A-Z]/g, ' $&');
  } // transform
} // class
